/**
 * Voice limiting (DOM-free): vanilla's sound engine caps simultaneous
 * channels (~247 static) and the same event stacks up only so far. When over a
 * limit the oldest voice is stolen.
 */
export const MAX_VOICES = 247;
export const MAX_PER_SOUND = 8;

export interface Voice { id: string; start: number; stop(): void }

export class VoiceLimiter {
  readonly active: Voice[] = [];
  constructor(readonly maxTotal = MAX_VOICES, readonly maxPerSound = MAX_PER_SOUND) {}

  /** Register a new voice, stopping whatever it displaces. Returns the stolen voices. */
  add(v: Voice): Voice[] {
    const stolen: Voice[] = [];
    let same = 0;
    for (const a of this.active) if (a.id === v.id) same++;
    while (same >= this.maxPerSound) {
      const i = this.active.findIndex((a) => a.id === v.id);
      stolen.push(...this.active.splice(i, 1));
      same--;
    }
    while (this.active.length >= this.maxTotal) stolen.push(this.active.shift()!);
    for (const s of stolen) s.stop();
    this.active.push(v);
    return stolen;
  }

  remove(v: Voice): void {
    const i = this.active.indexOf(v);
    if (i >= 0) this.active.splice(i, 1);
  }

  count(id?: string): number {
    return id === undefined ? this.active.length : this.active.reduce((n, a) => n + (a.id === id ? 1 : 0), 0);
  }
}
